import { render, staticRenderFns } from "./orgBasesList.vue?vue&type=template&id=4a857ee8&scoped=true"
import script from "./orgBasesList.vue?vue&type=script&lang=js"
export * from "./orgBasesList.vue?vue&type=script&lang=js"
import style0 from "./orgBasesList.vue?vue&type=style&index=0&id=4a857ee8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a857ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a857ee8')) {
      api.createRecord('4a857ee8', component.options)
    } else {
      api.reload('4a857ee8', component.options)
    }
    module.hot.accept("./orgBasesList.vue?vue&type=template&id=4a857ee8&scoped=true", function () {
      api.rerender('4a857ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/orgBasesList.vue"
export default component.exports